import Image from "next/image";
import { FC } from "react";
import { Integration } from "./IntegrationsData";
import Link from "next/link";

interface TabsContentProps {
  tabId: string;
  label: string;
  listData: Integration[];
}

const TabsContent: FC<TabsContentProps> = ({ tabId, label, listData }) => (
  <>
    <h3 id={tabId} className="my-4 text-[16px] font-semibold text-[#202020]">
      {label}
    </h3>
    <div
      key={listData?.length}
      className="mx-auto grid max-w-screen-2xl grid-cols-1 gap-2 lg:grid-cols-2 lg:gap-4"
    >
      {listData.map((item) => (
        <Link
          key={item.id}
          href={item.url || "#"}
          className="relative rounded-[8px] flex items-start gap-2 xl:gap-4 bg-white p-4 hover:bg-[#F0F4FF]"
        >
          <div>
            <Image
              src={item.icon}
              alt={`${item.title} integration logo`}
              className="w-[2rem] xl:w-[4rem]"
            />
          </div>
          <div className="flex flex-col gap-1 overflow-hidden md:gap-[6px]">
            <h4 className="text-[16px] font-medium text-[#202020]">
              {item.title}
            </h4>
            <p className="text-[14px] text-[#717171]">{item.description}</p>
          </div>
        </Link>
      ))}
    </div>
  </>
);
export default TabsContent;
